module.exports = __webpack_public_path__ + "static/media/om.289c4ffe.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/om.svg
// module id = 912
// module chunks = 0